import styled from 'styled-components';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Card = styled(SegmentLayoutComponent)`
  height: 250px;
  min-width: 200px;

  &.ui.segment {
    padding: 20px;
  }
`;

const Title = styled(TextLayoutComponent.Header)`
  margin-bottom: 25px;
`;

export {
  Card,
  Title,
};
